import { TDiversCartMiniTable } from "../../types/DiversificacionCarteraTypes"

export const INITIAL_MINITABLE: TDiversCartMiniTable = {
    volatilidad: 0,
    mejoriaDiversificacion: 0,
    reduccionDeRiesgo: 0,
    indiceDiversificacion: 0,
    numeroInstrumentos: 0,
    fecha: new Date()
}
export const INITIAL_CIRCLEGRAPH = [
    {
        tipoActivo1: '',
        riesgo: 0,
    }
]
export const INITIAL_CIRCLEGRAPH2 = [
    {
        tipoActivo1: '',
        tipoActivo2: '',
        riesgo: 0,
    }
]

export const INITIAL_SCREEN_DATA = {
    inferior: {
        nomcontrato: '',
        totalPeso: 0,
        volatilidadCorrelacion1: 0,
        volatilidadCorrelacionReal: 0,
        totalDiferencia: 0
    },
    activo1: [],
    activo1y2: [],
    maxLevelDetail: [],
    activo1Riesgo: [],
    activo1y2Riesgo: [],
    miniTable: {
        volatilidad: 0,
        mejoriaDiversificacion: 0,
        reduccionDeRiesgo: 0,
        indiceDiversificacion: 0,
        numeroInstrumentos: 0,
        fecha: new Date
    },
    waterfall: []
}